module.exports = __webpack_public_path__ + "static/media/as_bt2.88ae4986.png";